import { maybeLocale } from '@wework/universal-locale-utils';
import { varsFromServer } from '../client_side_injection_vars';

export function localizeLink({ to = '/', locale = getLocale() }) {
  const separator = to[0] === '/' ? '' : '/';
  const link = `${maybeLocale(locale)}${separator}${to}`;
  return link;
}

export function getLocale() {
  const DEFAULT_LOCALE = 'en';
  return varsFromServer.locale || DEFAULT_LOCALE;
}

export function getSelectedLocale() {
  return varsFromServer.locale;
}

export function stripOutLocale(url = '') {
  if (url) {
    return url.replace(/([a-z]{2}-[A-Z]{2}\/)/g, '');
  }
  return url;
}

export function ISODateToLocalizedShortDate(date, utc = true) {
  const { locale } = varsFromServer;
  const options = {
    month: 'short',
    day: '2-digit',
    ...(utc && { timeZone: 'UTC' })
  };

  const currentYear = new Date().getFullYear();
  const datesYear = new Date(date).getFullYear();
  if (datesYear > currentYear) {
    options.year = 'numeric';
  }

  const shortDate = new Date(date).toLocaleDateString(locale, options);
  return shortDate;
}

/**
 * - The users locale based on browser setting is always sent into Salesforce
 * - Footer locale does not impact what is being sent into SalesForce
 meaning if they have fr_FR on the footer but browser is en_GB, we are sending en_GB to SalesForce
 * - If our page does not support the users browser locale and we serve up an en_US page we should still send over the browser locale
 meaning if the user has ca_ES as their browser locale and the page they are on does not have that page translated and instead displays en_US we should still send to SalesForce ca_ES
 * - If the user has multiple locales set in their browser we are only sending the first locale set as the highest priority into SalesForce
 *
 * @returns {*|string}
 */
export function getBrowserPreferredLanguage() {
  return (
    navigator.language /* the user's preferred language */ ||
    (navigator.languages && navigator.languages[0]) /* the most user's preferred language */ ||
    navigator.userLanguage /* the operating system’s natural language */
  );
}
